import React from "react";
import { IconButton } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import css from "./EntityRow.module.css";
/**
 * Compact list row for a repeatable form entry: a wrapping fields summary on
 * the left and always-visible edit/delete icon actions on the right. Replaces
 * wide multi-column tables that overflowed in the narrow title form pane.
 */
export var EntityRow = React.forwardRef(function (_a, ref) {
    var children = _a.children, onEdit = _a.onEdit, onDelete = _a.onDelete, _b = _a.canDelete, canDelete = _b === void 0 ? true : _b, dragHandle = _a.dragHandle, style = _a.style, className = _a.className;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement("div", { ref: ref, className: [css.row, className].filter(Boolean).join(" "), style: style },
        dragHandle,
        React.createElement("div", { className: css.summary }, children),
        React.createElement("div", { className: css.actions },
            React.createElement(IconButton, { icon: "edit", onClick: onEdit, "aria-label": formatMessage({ id: "ui-br-agency.button.edit" }) }),
            onDelete && canDelete && (React.createElement(IconButton, { icon: "trash", onClick: onDelete, "aria-label": formatMessage({ id: "ui-br-agency.button.delete" }) })))));
});
EntityRow.displayName = "EntityRow";
